exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-row[data-v-59693ef0]:hover {\n  cursor: pointer;\n  background-color: #f5f5f5;\n}\n.v-table .v-table__wrapper > table > thead > tr > th[data-v-59693ef0] {\n  color: #777;\n  font-weight: bold;\n  line-height: 20px;\n  padding: 3px 5px;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  font-size: 14px;\n  border-top: none;\n}\n.v-table .v-table__wrapper > table > tbody > tr > td[data-v-59693ef0] {\n  padding: 8px;\n  line-height: 20px;\n  text-align: left;\n  vertical-align: top;\n  color: #333;\n  font-size: 13px;\n}\n\n", ""]);

// exports
